module.exports = "/fast-coin/img/coin/anim/shine_2/shine_2_029.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/shine_2/shine_2_029.png
// module id = 2376
// module chunks = 5